import { render, staticRenderFns } from "./InternalData.vue?vue&type=template&id=12bd3de8&"
import script from "./InternalData.vue?vue&type=script&lang=js&"
export * from "./InternalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports